<template>
    <div class="candidate-shift-step">
        <div class="row">
            <div
                v-for="day in weekDays"
                :key="day.key"
                class="col-sm-6 col-lg-4 mb-3"
            >
                <app-form-group-selectable
                    type="select"
                    :label="day.label"
                    :id="`candidate-shift-${day.key}`"
                    list-value-field="name"
                    v-model="candidateForm[day.key]"
                    :required="requireShift"
                    :chooseLabel="$t('time')"
                    :options="timeOptions"
                    :error-message="$errorMessage(formErrors, day.key)"
                />
            </div>
            <div class="col-sm-6 col-lg-4 mb-3">
                <app-form-group
                    type="date"
                    id="candidate-shift-start-date"
                    :label="$t('start_date') + '<span class=\'text-danger ml-1\'>*</span>'"
                    :placeholder="candidateForm.start ? $placeholder('start_date') : $t('not_added_yet')"
                    v-model="candidateForm.start"
                    :required="true"
                    :error-message="$errorMessage(formErrors, 'start')"
                />
            </div>
        </div>

        <div class="mt-3">
            <app-form-group
                type="textarea"
                id="candidate-shift-remark"
                :text-area-rows="5"
                label-alignment="top"
                :label="$t('remark')"
                :placeholder="$textAreaPlaceHolder('remark')"
                v-model="candidateForm.remark"
                :error-message="$errorMessage(formErrors, 'remark')"
            />
        </div>

        <div class="d-flex justify-content-between mt-4">
            <button type="button" class="btn btn-dark" @click="goBack" :disabled="isValidating">
                {{ $t('back') }}
            </button>
            <div>
                <button
                    v-if="!requireShift"
                    type="button"
                    class="btn btn-primary mr-2"
                    @click="goNext"
                    :disabled="isValidating"
                >
                    {{ $t('skip') }}
                </button>
                <button type="button" class="btn btn-primary" @click="goNext" :disabled="isValidating">
                    {{ $t('next') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import FormHelperMixins from "../../../../../../common/Mixin/Global/FormHelperMixins";
import {axiosGet} from "../../../../../../common/Helper/AxiosHelper";
import {TENANT_BASE_URL} from "../../../../../../common/Config/UrlHelper";

export default {
    name: "CandidateShiftStep",
    mixins: [FormHelperMixins],
    props: {
        props: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            requireShift: true,
            isValidating: false,
        };
    },
    computed: {
        candidateForm() {
            return this.props.formData || {};
        },
        formErrors() {
            return this.props.errors || {};
        },
        timeOptions() {
            return this.props.timeList || [];
        },
        weekDays() {
            return [
                {key: 'monday', label: this.requiredLabel(this.$t('monday'))},
                {key: 'tuesday', label: this.requiredLabel(this.$t('tuesday'))},
                {key: 'wednesday', label: this.requiredLabel(this.$t('wednesday'))},
                {key: 'thursday', label: this.requiredLabel(this.$t('thursday'))},
                {key: 'friday', label: this.requiredLabel(this.$t('friday'))},
                {key: 'saturday', label: this.requiredLabel(this.$t('saturday'))},
                {key: 'sunday', label: this.requiredLabel(this.$t('sunday'))}
            ];
        },
        shiftFields() {
            const dayKeys = this.weekDays.map(day => day.key);
            return [...dayKeys, 'start', 'remark'];
        }
    },
    methods: {
        requiredLabel(text) {
            if (!this.requireShift) {
                return text;
            }

            return `${text}<span class='text-danger ml-1'>*</span>`;
        },
        goBack() {
            this.$emit('back', true);
        },
        async goNext() {
            if (this.isValidating) {
                return;
            }

            const validateStep = this.props.validateStep;
            if (typeof validateStep === 'function') {
                this.isValidating = true;
                const isValid = await validateStep(this.shiftFields);
                this.isValidating = false;

                if (!isValid) {
                    return;
                }
            }

            this.$emit('next', true);
        },
        fetchWorkPlaceDetail() {
            axiosGet(`${TENANT_BASE_URL}api/work-place/${this.props.workPlaceId}`)
                .then(({data}) => {
                    this.requireShift = !!data.require_shift;
                })
                .catch(error => {
                    console.error('Failed to load work place detail', error?.response?.data || error);
                });
        }
    },
    created() {
        this.fetchWorkPlaceDetail();
    }
}
</script>
